import { ClinicSalesPackages, IClinicSalesPackages } from '@common/models/ClinicSalesPackages';
import { SalesPackageModel, ISalesPackageModel } from '@common/models/SalesPackageModel';
import { http } from '@common/utils';
import { DateTime } from 'luxon';
import { trackPromise } from 'react-promise-tracker';

export class SalesPackageService {
    private static baseUrl: string = '/api/salesPackage';
    static tags = {
        deleteSalesPackages: "deleteSalesPackages",
        getSalesPackage: "getSalesPackage",
        upsertSalesPackage: "upsertSalesPackage",
        getClinicSalesPackages: "getClinicSalesPackages"
    }

    static deleteSalesPackages = (salesPackageId: number): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}/delete/${salesPackageId}`).delete()
                .then(() => {
                    resolve(true);
                })
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.deleteSalesPackages);
    }
    static getSalesPackage = (salesPackageId: number): Promise<SalesPackageModel> => {
        return trackPromise(new Promise<SalesPackageModel>((resolve, reject) => {
            http(`${this.baseUrl}/${salesPackageId}`).get<ISalesPackageModel>()
                .then((response) => new SalesPackageModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.getSalesPackage);
    };
    static upsertSalesPackage = (data: ISalesPackageModel): Promise<SalesPackageModel> => {
        return trackPromise(new Promise<SalesPackageModel>((resolve, reject) => {
            http(`${this.baseUrl}/update/`).post<ISalesPackageModel>(data)
                .then((response) => new SalesPackageModel(response))
                .then(resolve)
                .catch((err) => {
                    reject(err);
                })
        }), this.tags.upsertSalesPackage);
    }
    static getClinicSalesPackages = (clinicId: number, clinicDate: DateTime): Promise<SalesPackageModel[]> =>
        trackPromise(new Promise<SalesPackageModel[]>((resolve, reject) => {
            http(`${this.baseUrl}/${clinicDate.toISODate()}/clinic/${clinicId}`)
                .getVersioned<IClinicSalesPackages>(`sales-packages-${clinicDate.toISODate()}-${clinicId}`)
                .then(json => new ClinicSalesPackages(json))
                .then(csp => resolve(csp.salesPackages))
                .catch(reject)
        }), this.tags.getClinicSalesPackages);
}
